/*!
 * www.sangetsu.co.jp - showroom.min.js
 * @generated Fri Jun 02 2017 14:05:57 GMT+0900 (東京 (標準時))
 */
'use strict';

/* !
 * jQuery showroom v1.0.0
 * Copyright 2016, Connecty Inc.
 */
(function ($, SANGETSU, cssua) {
	var clickEvent = cssua.ua.desktop ? 'click' : 'touchstart';
	var v = 'is-visible';
	var a = 'is-active';
	var slideSpeed = 'fast';
	var $tab = $('.js-showroom-thumb');
	var $content = $('.showroom-detail-main-topImage');
	var $border = $('.showroom-index-main-view-border');
	var $news = $('.showroom-info-box_news');
	var $event = $('.showroom-info-box_event');
	var $newsSwitch = $('.js-showroom-info_news');
	var $eventSwitch = $('.js-showroom-info_event');
	var $float = $('.showroom-float');

	// メイン画像切り替え
	$tab.on(clickEvent, function () {
		$tab.each(function () {
			$(this).removeClass(a);
		});
		$(this).addClass(a);

		$content.each(function () {
			$(this).removeClass(a).removeClass(v);
		});

		var $switch = $('#' + $(this).attr('data-switch'));
		$switch.addClass(a);
		setTimeout(function () {
			$switch.addClass(v);
		}, '200');
	});

	// フロア画像切り替え（英・中）
	var $tabEn = $('.js-english-tab');
	$tabEn.on(clickEvent, function () {
		$(this).parents('.english-showroom-display-thumb-inner-list').find('.js-english-tab').each(function () {
			$(this).removeClass(a);
		});
		$(this).addClass(a);

		$(this).parents('.english-showroom-display-parent').find('.js-english-tab-content').each(function () {
			$(this).removeClass(a).removeClass(v);
		});

		var $switch = $('#' + $(this).attr('data-switch'));
		$switch.addClass(a);
		setTimeout(function () {
			$switch.addClass(v);
		}, '200');
	});

	var $tabCh = $('.js-chinese-tab');
	$tabCh.on(clickEvent, function () {
		$(this).parents('.chinese-showroom-display-thumb-inner-list').find('.js-chinese-tab').each(function () {
			$(this).removeClass(a);
		});
		$(this).addClass(a);

		$(this).parents('.chinese-showroom-display-parent').find('.js-chinese-tab-content').each(function () {
			$(this).removeClass(a).removeClass(v);
		});

		var $switch = $('#' + $(this).attr('data-switch'));
		$switch.addClass(a);
		setTimeout(function () {
			$switch.addClass(v);
		}, '200');
	});

	if (cssua.ua.mobile) {
		$('.js-carousel').owlCarousel({
			items: 3,
			slideSpeed: 300,
			paginationSpeed: 400,
			pager: false,
			pagination: false,
			margin: 10,
			nav: true,
			navText: ['', '']
		});
	}

	// index 360°ビューロゴ回転
	$('.showroom-index-main-box').on('mouseenter', function () {
		$border.addClass('is-animate');
	}).on('mouseleave', function () {
		$border.removeClass('is-animate');
	});

	// お知らせ欄タブ切り替え（SPのみ）
	if (cssua.ua.mobile) {
		$newsSwitch.on(clickEvent, function () {
			$eventSwitch.removeClass(a);
			$newsSwitch.addClass(a);
			$event.removeClass(a);
			$news.addClass(a);
		});
		$('.js-showroom-info_event').on(clickEvent, function () {
			$newsSwitch.removeClass(a);
			$eventSwitch.addClass(a);
			$news.removeClass(a);
			$event.addClass(a);
		});
	}

	// 別ページからタブへ直接移動
	if (SANGETSU.va.hash.indexOf('showroom-index') !== -1) {
		setTimeout(function () {
			var pos = $('#usage-tab').offset().top;
			$('html,body').stop().animate({ scrollTop: pos }, slideSpeed, 'easeOutExpo');

			$('.showroom-index-tab-content, .js-tab').removeClass(a).removeClass(v);
			$('.js-tab[data-switch=' + SANGETSU.va.hash.replace(/#/g, '') + ']').addClass(a);
			$(SANGETSU.va.hash).addClass(v).addClass(a);
		}, '500');
	}

	// フロート予約ボタン、ご案内ボタン
	$(window).scroll(function () {
		if ($(window).scrollTop() > '300') {
			$float.addClass(v);
		} else {
			$float.removeClass(v);
		}
	});
})(window.jQuery, window.SANGETSU, window.cssua);